<template>  
  <div class="sellservicemsg">
    <XR-head titleText="给卖家留言"></XR-head>
    <div class="form">
      <mu-row gutter>
        <mu-col width="100" tablet="50" desktop="33">
        <div class="remark">      
          <mu-text-field  label="留言内容" hintText="请输入您要留言的内容" multiLine :rows="3" :rowsMax="6" :maxLength="50" v-model="msgInfo.Content" fullWidth />
        </div>
        </mu-col>
      </mu-row>
    </div>
    <mu-row gutter>
      <mu-col width="100" tablet="50" desktop="33" class="button-row">
        <mu-raised-button label="确 定" class="submit" primary fullWidth @click="sellServiceOrderMsg()" />
      </mu-col>
    </mu-row>
    <XR-toast @onClose="goBack" ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
export default {
  data () {
    return {
      msgInfo:{
        SellServiceNo:this.$route.query.sellServiceNo,
        Content:''
      }
    }
  },
  mounted(){
  },
  methods: {
    sellServiceOrderMsg(){      
      var ths = this;   
      ths.$post(
        "/Shop/RetailServer/SellServiceOrderSendMessage",
        JSON.stringify(this.msgInfo)
      ).then(function(res) {
        if(!res.IsSuccess){     
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.$refs.XRtoast.success(res.Msg, true)
        }
      });
    },
    goBack(){
      this.$router.goBack()
    }
  }
}
</script>

<style>
.sellservicemsg .form{
  background: white;
  padding: 10px;
}
.sellservicemsg .remark{
  background: white;
}
.sellservicemsg .button-row{  
  padding: 40px 20px 0 20px;
}
.sellservicemsg .submit{
  height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/sellservicemsg.vue